import {
  Input as ChakraInput,
  InputProps as ChakraInputProps,
} from '@chakra-ui/react'
import React from 'react'
import { currencyFormatter } from './inputFormatters'

export interface InputProps extends ChakraInputProps {
  isCurrency?: boolean
}

export type InputValueType = string | number | readonly string[] | undefined

export const Input = ({ value, isCurrency, ...props }: InputProps) => {
  let displayedValue: InputValueType = value
  let rawValue: InputValueType | null = null

  if (isCurrency) {
    const formattedData = currencyFormatter(value)
    displayedValue = formattedData.display
    rawValue = formattedData.raw
  }

  return (
    <ChakraInput
      bg="white"
      borderRadius="0"
      errorBorderColor="red.500"
      borderColor="gray.500"
      value={displayedValue}
      data-raw={isCurrency ? rawValue : displayedValue}
      {...props}
    />
  )
}
